export var NotificationType;
(function (NotificationType) {
    NotificationType["Popup"] = "popup";
})(NotificationType || (NotificationType = {}));
export var NotificationState;
(function (NotificationState) {
    NotificationState["Read"] = "read";
    NotificationState["Unread"] = "unread";
})(NotificationState || (NotificationState = {}));
export var NotificationTargetType;
(function (NotificationTargetType) {
    NotificationTargetType["All"] = "all";
    NotificationTargetType["PointsEligible"] = "pointsEligible";
    NotificationTargetType["User"] = "user";
    NotificationTargetType["Group"] = "group";
})(NotificationTargetType || (NotificationTargetType = {}));
